export function RefundReturn() {
  return (
    <>
      <div className="px-2">
        <h1 className="font-semibold text-lg">Return and Refund Policy</h1>
        <p className="text-justify mt-4">
          Thank you for your interest in our clothing brand shamaim.in. We
          understand the importance of having a clear return and refund policy,
          and we strive to provide a seamless shopping experience for our
          customers. Below is our return and refund policy.
        </p>
        <p className="text-justify mt-4">
          <span className="font-semibold">Returns:</span> We accept returns
          within 5 days of delivery. To initiate a return, Log in to{" "}
          <span className="font-semibold text-sm">shamaim.in</span> then tap on{" "}
          <span className="font-semibold">Account</span> and go to{" "}
          <span className="font-semibold">Orders</span> tab. Select the product(s) you wish to return and Tap or click on Return to create a request.
        </p>

        <p className="text-justify mt-4">
          Select your applicable{" "}
          <span className="font-semibold">reason of return and fill in the return form —</span>
          based on 2 options will be available:
        </p>
        <ul className="pl-4 mt-2">
          <li className="text-sm">1) Complete Refund or Return</li>
          <li className="text-sm">2) Replace</li>
        </ul>
        <h2 className="font-bold text-base mt-4">1) Return</h2>
        <p className="text-justify">
          To be eligible for a return, the item must meet the following criteria:
        </p>

        <ul className="pl-4 mt-2">
          <li className="text-sm">• It should be unused, unwashed, and in the same condition as received.</li>
          <li className="text-sm">• The item should be in its original packaging with all tags attached.</li>
          <li className="text-sm">• The original bill or receipt must be provided as proof of purchase.</li>
          <li className="text-sm">• The return request must be initiated within 5 days of delivery.</li>
          <li className="text-sm">• Keep ready all the requisite items necessary for a smooth returns process — including invoice, original packaging, price tags, freebies, accessories, etc.</li>
          <li className="text-sm">• The product should not be damaged or tampered with. Once the return request is approved, customers will receive a confirmation email with the details of the return process. Our logistics partner will pick up the product(s) from the customer's location.</li>
        </ul>
        <p className="text-justify mt-1">
          <span className="font-semibold">Refund:</span> Customers will receive a refund in their Bank Account within 3 to 5 working days of the brand receiving the returned product(s). The refund amount will be equal to the product price minus any discounts applied.
        </p>
        <div className="flex flex-col space-y-2 mt-4">
          <h2 className="font-bold text-base">Refunds</h2>
          <p className="text-justify">
            Once we receive and inspect the returned item, we will notify you of
            the approval of your refund. If the return is approved, the refund
            will be processed within a reasonable timeframe.
          </p>
          <p className="text-justify">
            Refunds for eligible returns will be transferred to your bank
            account only. To initiate the refund, we will require your bank
            account details, such as the account holder's name, Bank Name,
            account number, and IFSC code. Please ensure the provided
            information is accurate to avoid any delays or issues with the
            refund process.
          </p>
          <p className="text-justify">
            Please note that the refund amount may vary depending on the
            condition of the returned item and any applicable deductions, such
            as shipping fees or restocking charges.
          </p>
          <p className="text-justify">
            We strive to process refunds as quickly as possible, but the actual
            time it takes for the refund to reflect in your bank account may
            vary based on your bank's policies and processing times.
          </p>
        </div>

        <p className="text-justify mt-4">
          <span className="font-bold text-base">Replacement:</span> Your order will be exchanged for a new identical product of a different size or color. The item will be picked up by our logistics partner, and the new product will be delivered within 5-7 working days from filing the replacement request.
        </p>

        <p className="text-justify mt-4">
          If you have any further questions or concerns regarding our return and refund policy, please don't hesitate to reach out to our customer support team at <a href="mailto:help@shamaim.in" className="text-blue-500 hover:underline">help@shamaim.in</a> for assistance. We are here to help you.
        </p>
        
        <p className="text-justify mt-4">
          <span className="font-semibold">Non-refundable Items:</span> The following items are non-refundable: • Personalized or custom-made products • Products that have been used or damaged by the customer
        </p>

        <p className="text-justify mt-4 mb-5">
       <span className=" font-bold">cancellion policy : </span> Customers are not eligible for cancellation  
        </p>
      </div>
    </>
  );
}
